import React from 'react';

const AdminDetail: React.FC = () => {
  return <div>AdminDetail</div>;
};

export default AdminDetail;
